import OneCardConsumption from '../views/OneCardSystem/Consumption.vue'
import Home from '../views/Home.vue'
import NotFound from '../views/404.vue'

const routeOnceCard = 
     [    
    {
      path:'/',
      component: Home,
      hidden: true
    },
        
        {
            
            path: '/',
            component: (resolve) => require(['../views/Home.vue'], resolve),
            name: '消费管理',
            iconCls: 'fa fa-bar-chart',
            children: [
                // { path: '/ResetLog', component: ResetLog, name: '重置日志' },
                { path: '/OneCardConsumption', component: OneCardConsumption, name: '一卡通消费' },                                      
            ]
        },           
        {
            path: '/404',
            component: NotFound,
            name: '',
            hidden: true
        },
        {
            path: '*',
            hidden: true,
            redirect: { path: '/404' }
        }
    ];
 
    

export default routeOnceCard;


// WEBPACK FOOTER //
// ./src/userroutes/OneCardSystem.js